import { Pipe, PipeTransform } from '@angular/core';
import { DocumentCalculationMethodEnum } from '@zaoblako/shared/modules/document/enums/document.calculation.method.enum';

const DocumentCalculationMethodNames: Record<DocumentCalculationMethodEnum, string> = {
  [DocumentCalculationMethodEnum.KASS]: 'Кассовый метод',
  [DocumentCalculationMethodEnum.SALE]: 'Метод начислений'
};

@Pipe({
  standalone: true,
  name: 'documentCalculationMethodName'
})
export class DocumentCalculationMethodNamePipe implements PipeTransform {
  public transform(documentCalculationMethod: DocumentCalculationMethodEnum): string {
    return DocumentCalculationMethodNames[documentCalculationMethod] || '';
  }
}
